var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 378 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.375 181.125C200.812 210.766 173.25 283.5 173.25 283.5C173.25 283.5 133.875 181.125 94.5 157.5",
    className: "svgStroke",
    strokeWidth: 23.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.736 121.747L288.414 170.257C291.438 201.726 267.845 229.745 236.376 232.785C205.506 235.746 177.534 213.176 174.557 182.306C173.849 174.963 174.594 167.553 176.75 160.498C178.906 153.444 182.431 146.883 187.123 141.19C191.815 135.498 197.582 130.786 204.095 127.323C210.609 123.86 217.74 121.714 225.083 121.007L276.806 116.03C278.483 115.872 280.154 116.385 281.453 117.457C282.752 118.528 283.573 120.071 283.736 121.747V121.747Z",
    className: "svgStroke",
    strokeWidth: 23.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189 346.5C275.987 346.5 346.5 275.987 346.5 189C346.5 102.013 275.987 31.5 189 31.5C102.013 31.5 31.5 102.013 31.5 189C31.5 275.987 102.013 346.5 189 346.5Z",
    className: "svgStroke",
    strokeWidth: 23.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/vegan.484320a4.svg";
export { ForwardRef as ReactComponent };